module.exports = __webpack_public_path__ + "ec6763a93e92ec01f28c4ad3d8425ffb.svg";